<template>
  <div
    id="tab1"
    class="t-color-gray2 pdl-16 pdr-16 pdt-16 pdb-34"
    style="height: 100vh"
  >
    <!-- <div class="h-50"></div>
        <div class="h-32"></div> -->
    <img
      src="/images/helpdesk/notice_nodata.svg"
      alt=""
      class="mgx-auto no-data-image"
    />
    <div
      class="pdt-24 pdl-16 pdr-16 pdb-4 t-subtitle3 t-color-title t-center font-m l-spacing48"
    >
      {{ boardId == "BOARD1" ? $t("1513") : $t("1515") }}
      <!-- {{ $t("1494") }} -->
    </div>
    <div
      class="pdt-4 pdl-16 pdr-16 pdb-4 t-body3 t-color-content1 t-center l-spacing42"
    >
      {{ boardId == "BOARD1" ? $t("1514") : $t("1516") }}
      <!-- {{ $t("1495") }} -->
    </div>
  </div>
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  props: ["boardId"],
};
</script>

<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
  letter-spacing: -0.6;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.listItems {
  border-bottom: 1px solid #e6eced;
}
.no-data-image {
  width: 123px;
  height: 143px;
  margin-top: 59px;
}

#tab1,
#tab2 {
  margin-top: 56px;
}
</style>